import { createFileRoute, redirect } from '@tanstack/react-router'
import { startOfDay } from 'date-fns'
import { parse } from 'valibot'

import {
  fetchCustomerContracts,
  type FetchCustomerContractsQuery
} from '@/features/customer-contracts/api'

import { selectedDcIdAtom, tenantStore } from '../../-states'

import { CustomerContractsSearchSchema } from './-models'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/customer-contracts/'
)({
  validateSearch: (search) => parse(CustomerContractsSearchSchema, search),
  loaderDeps: ({ search }) => search,
  beforeLoad: ({ search, location }) => {
    const selectedDcId = tenantStore.get(selectedDcIdAtom)
    // クエリの有無で初回アクセスかどうかを判定
    const keys = Object.keys(search)

    // 初回アクセス（クエリが空）の場合は、選択中のDCと isApplying=true を既定付与
    if (keys.length === 0) {
      throw redirect({
        to: location.pathname,
        search: {
          ...search,
          dcId: selectedDcId,
          isApplying: true,
          operatingDate: startOfDay(new Date()).toISOString()
        }
      })
    }

    if (search.dcId != selectedDcId) {
      throw redirect({
        to: location.pathname,
        search: {
          ...search,
          dcId: selectedDcId
        }
      })
    }
  },
  loader: async ({
    abortController,
    params: { tenantKey },
    deps,
    context: { auth }
  }) => {
    const query: FetchCustomerContractsQuery = {
      tenantKey,
      query: deps
    }
    return {
      authUser: auth.user,
      customerContracts: await fetchCustomerContracts(
        query,
        abortController.signal
      )
    }
  }
})
